var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingAndPaymentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9035_5493",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1677",
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9035_5493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1683",
    d: "M10 14.7266C10 17.3154 7.90133 19.4141 5.3125 19.4141C2.72367 19.4141 0.625 17.3154 0.625 14.7266C0.625 12.1377 2.72367 10.0391 5.3125 10.0391C7.90133 10.0391 10 12.1377 10 14.7266Z",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1687",
    d: "M4.98699 14.7266H5.63805C5.99762 14.7266 6.28906 15.018 6.28906 15.3776V16.0286C6.28906 16.3882 5.99762 16.6797 5.63805 16.6797H4.98699C4.62742 16.6797 4.33594 16.3882 4.33594 16.0286",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1691",
    d: "M5.63801 14.7266H4.98695C4.62738 14.7266 4.33594 14.4351 4.33594 14.0755V13.4245C4.33594 13.0649 4.62738 12.7734 4.98695 12.7734H5.63801C5.99758 12.7734 6.28906 13.0649 6.28906 13.4245",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1695",
    d: "M5.3125 12.7734V11.9922",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1699",
    d: "M5.3125 17.4609V16.6797",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1703",
    d: "M5.3125 19.4141H18.2031C18.8503 19.4141 19.375 18.8894 19.375 18.2422V4.49231L15.4689 0.585939H6.48438C5.83719 0.585939 5.3125 1.11063 5.3125 1.75781V10.0391",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1707",
    d: "M15.4688 0.585938V4.49219H19.375L15.4688 0.585938Z",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1711",
    d: "M8.4126 11.2109H16.6406",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1715",
    d: "M8.04688 7.69531H16.6406",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1719",
    d: "M10 14.7266H16.6406",
    stroke: "#0A0F0D",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAndPaymentIcon);
export default __webpack_public_path__ + "static/media/BillingAndPaymentIcon.01f9f0ff478edb2cb1d9bc10ee31bd80.svg";
export { ForwardRef as ReactComponent };